import React, { useEffect } from 'react';
import { useState } from 'react'
import Otp from './otp';
import Fixedbg from '../FixedBaground/Fixedbg';
import Header from '../Header/header';
import env from 'react-dotenv';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '@/config/serverApiConfig';
import { Modal, Spinner } from 'react-bootstrap';
import SubmitPopup from '../Submitpopup/Submitpopup';
import Footer from '../Footer/footer';
import { AvForm, AvField } from "availity-reactstrap-validation";
import ReCAPTCHA from "react-google-recaptcha";

import {
  Card,
  CardTitle,
  CardBody,
  FormGroup,
  Label,
  Button,
  Container,
} from "reactstrap";
import { Col, Row } from 'antd';
//import styles from "../index.css";


const Login = () => {

  const history = useHistory();

  useEffect(() => {

    if (localStorage.getItem("token") === undefined || localStorage.getItem("token") === null) {
      history.push('/login');
    }
    else {
      history.push('/dashboard');
    }

  }, []);



  const [email, setEmail] = useState('')
  const [emailErr, setEmailErr] = useState(false);
  const [emailIsEmptyErr, setemailIsEmptyErr] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  // const [submitLoader, setSubmitLoader] = useState(false);

  const loaderClose = () => setSubmitLoader(false);

  const [smShow, setSmShow] = useState(false);

  const [resLogin, setresLogin] = useState(
    {
      message: "",
      success: "",
      data: {
        user_id: "",
        email: ""
      }
    }
  );
  let [recap, setRecap] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  function onChange(value) {
    console.log("Captcha value:", value);
    if(value){
       setRecap(true);
       setRecaptchaError(false);
    }
  }


  const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );
  function userHandler(e) {

    let item = e.target.value;

    let validEmail = validEmailRegex.test(item);
    if (item === "") {
      setemailIsEmptyErr(true);
      setEmailErr(false);
    }

    else if (!validEmail) {
      setEmailErr(true)
      setemailIsEmptyErr(false);
    }
    else {
      setEmailErr(false)
      setemailIsEmptyErr(false)

    }
    setEmail(item)


  }
  let [userID, setUserID] = useState("");
  const recaptchaRef = React.useRef();
  let token ='';
  async function loginUser(event) {

    event.preventDefault()

    token = await recaptchaRef.current.executeAsync();
    
    if(token === false  || token === undefined|| token === null || token === ''){
      setRecaptchaError(true);
   }
   
    else if (email === "") {
      setemailIsEmptyErr(true);
      setEmailErr(false);
    }
    else if (!validEmailRegex.test(email)) {
      setEmailErr(true)
      setemailIsEmptyErr(false);
    }
     
    else {
      setSubmitLoader(true);
      

      axios.post(`${API_BASE_URL}user/login`, {
        email,
      })
        .then(function (response) {
          //console.log(response.data)
          setresLogin(response.data)
          console.log(resLogin)

          localStorage.setItem('user_id', response.data.data.user_id)
          //console.log(response.data)
          
          setUserID(response.data.data.user_id)
          setSubmitLoader(false);
          setSmShow(true)
          
          
        })
        .catch(function (error) {
          setUserID("")
          setSubmitLoader(false);
          setSmShow(true);
         
          
        });

      const handleClose = () => {
        return (
          <SubmitPopup />
        );
      }




    }
  }



  return (
    <>
      <Header />
      {/* <Modal
        size="sm"
        show={smShow}
        onHide={() => setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Small Modal
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{resLogin.message}</Modal.Body>
      </Modal> */}
      <SubmitPopup
        onClose={() => setSmShow(false)}
        show={smShow}
        title={resLogin.message}
        
      />
      <section className='login_section pt-5'>
        <div className="container-fluid p-0 container-responsive">
          <div className="row">
            <div className="col-lg-5">
              <Fixedbg />
            </div>
            <div className="col-lg-6">
              <div className='row'>
                <div className="col">
                  <h2 className="h2_medum" > Welcome  <span className='color-9F7854 fw-bold'>back to KBD!</span></h2>
                  <p>Please enter your registered mobile number or email. You will receive an OTP shortly to complete the login process.</p>
                </div>
              </div>
              <AvForm className='pt-4' onValidSubmit={loginUser}>
                <div className="form-group pb-5" >
                  <label> <span className='color-9F7854 fw-bold'>Enter Registered Email</span></label>
                  <AvField
                    type="text"
                    validate={{
                      pattern: {
                        value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                        errorMessage: "Enter Valid Email Address",
                      },
                      required: {
                        required: true,
                        errorMessage: "Email Address is Required",
                      },
                    }} className='form-control border-0 border-bottom bg-transparent'
                    onChange={userHandler} name="name"
                    value={email}
                  />
                  {/* <input type="email" className="form-control border-0 border-bottom bg-transparent" aria-describedby="emailHelp" placeholder="Enter email" value={email} onChange={userHandler} /> */}
                  {/* {emailIsEmptyErr ? <span className="error-msg">Please enter an email address</span> : ""}
                  {emailErr ? <span className="error-msg">Enter a valid email address</span> : ""} */}
                </div>
                <div style={{alignItems: "center"}} className='d-flex justify-content-end pb-5'>
                
                              
                  {/* <Modal show={submitLoader} onHide={loaderClose}>
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </Modal> */}
                  {/* </div>
                  <div className='d-flex justify-content-end pb-5'> */}
                  
                  <button style={{height:"53px"}} type="submit" className={submitLoader ? "btn disable" : "btn"}>Resend OTP</button>
                  <Button style={{height:"53px"}} className={submitLoader ? "btn-full-color disable" : "btn-full-color"} type="submit">
                    <Spinner
                      as="span"
                      animation={submitLoader ? 'border' : ''}
                      size="sm"
                      role="status"
                      aria-hidden="false"
                    />   
                          Submit
                  </Button>
                </div>
                <ReCAPTCHA
                                sitekey="6LfXbVggAAAAAF20tZ9IMRYPIeWhnPJ3QJ12c1Bf"
                                ref={recaptchaRef}
        size="invisible"
                              />
                {
                                 recaptchaError ? (
                                    <span style={{marginBottom:"40px"}} className="error-msg">Please verify that you are not a robot</span>
                                 ) : (
                                    ""
                                 )
                                 
                              }
               
              </AvForm>
              <Otp  login={true} userID={userID} />
            </div>
            
           
          </div>
          <div className="resposive_footer">
            <Footer />
          </div>
        </div>
      </section>
    </>
  )
}
export default Login;